import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import InputBoxDisableTrans from "../Components/InputBoxDisableTrans";
import { LogoRegister } from "../Components/LogoRegister";
import RadioButton from "../Components/RadioButton";
import { ReactComponent as IconCrossRound } from "../Images/icon_cross_round.svg";
import { ReactComponent as IconInfo } from "../Images/icon_info.svg";
import logoEx from "../Images/logoEx.png";
import LogoExCustom from "../Images/logoEx_custom.png";
import LogoExNotTrans from "../Images/logoEx_notTrans.png";
import LogoExTrans from "../Images/logoEx_Trans.png";
import { ReactComponent as RightBracket } from "../Images/right_bracket.svg";
import LayoutModal from "../Layout/LayoutModal";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";
import { postFormData, postJson } from "../Utils/apiUtils";
import { showToast } from "../Utils/variables";
import AlarmApply from "./AlarmApply";

const getValidLogoVisibleType = (logoVisibleType) => {
  const parsedLogoVisibleType = Number(logoVisibleType);

  return [1, 2, 3].includes(parsedLogoVisibleType)
    ? parsedLogoVisibleType
    : 1;
};

const getStoredLogoVisibleType = () => {
  if (typeof localStorage === "undefined") {
    return 1;
  }

  return getValidLogoVisibleType(localStorage.getItem("logoVisibleType"));
};

const isFileValue = (value) =>
  typeof File !== "undefined" && value instanceof File;

const SetLogoBox = ({ handleClickBack, handleClickX }) => {
  const navigate = useNavigate();
  const [custom, setCustom] = useState(getStoredLogoVisibleType() - 1);
  const [nameKr, setNameKr] = useState("");
  const [nameEn, setNameEn] = useState("");
  const [appLogo, setAppLogo] = useState(null);
  const [initialLogoVisibleType, setInitialLogoVisibleType] = useState(
    getStoredLogoVisibleType()
  );
  const [initialNameKr, setInitialNameKr] = useState("");
  const [initialNameEn, setInitialNameEn] = useState("");
  const [hasPendingLogoFile, setHasPendingLogoFile] = useState(false);

  const getCompanyInfo = async () => {
    try {
      const res = await postJson("/dashboard/company/getCompanyInfo", {}, navigate);

      if (res.code === 200) {
        const nextLogoVisibleType = getValidLogoVisibleType(
          res.data.logoVisibleType ?? localStorage.getItem("logoVisibleType")
        );
        const nextNameKr = res.data.logoNameKr ?? "";
        const nextNameEn = res.data.logoNameEn ?? "";

        setCustom(nextLogoVisibleType - 1);
        setInitialLogoVisibleType(nextLogoVisibleType);
        setNameKr(nextNameKr);
        setInitialNameKr(nextNameKr);
        setNameEn(nextNameEn);
        setInitialNameEn(nextNameEn);
        setAppLogo(res.data.appLogo ?? null);
        setHasPendingLogoFile(false);
      }
    } catch (error) {
      console.error("기업 정보 가져오기 중 에러:", error);
    }
  };

  const handleUpdateLogoName = async () => {
    try {
      const formData = new FormData();
      if (custom === 2 && isFileValue(appLogo)) {
        formData.append("appImage", appLogo);
      }
      formData.append("logoVisibleType", custom + 1);
      formData.append("logoNameKr", nameKr);
      formData.append("logoNameEn", nameEn);

      const res = await postFormData(
        "/dashboard/company/updateLogoVisibleType",
        formData,
        navigate
      );

      if (res.code === 200) {
        const nextLogoVisibleType = custom + 1;

        localStorage.setItem("logoVisibleType", String(nextLogoVisibleType));
        setInitialLogoVisibleType(nextLogoVisibleType);
        setInitialNameKr(nameKr);
        setInitialNameEn(nameEn);
        setAppLogo(res.data?.appLogo ?? appLogo);
        setHasPendingLogoFile(false);
        showToast("앱 메인화면 변경이 완료되었습니다.", "success");
      } else {
        showToast("다시 한 번 시도해주세요.", "error");
      }
      setClickApply(false);
    } catch (error) {
      console.log("로고명 변경 중 에러");
      throw error;
    }
  };
  const [clickApply, setClickApply] = useState(false);

  const isValueDone =
    custom === 1
      ? nameKr && nameEn
      : custom === 2
      ? appLogo !== null
      : custom === 0;

  const isLogoVisibleTypeChanged = initialLogoVisibleType !== custom + 1;
  const isLogoNameChanged =
    custom === 1 && (initialNameKr !== nameKr || initialNameEn !== nameEn);
  const isLogoFileChanged = custom === 2 && hasPendingLogoFile;
  const isButtonEnabled =
    isValueDone &&
    (isLogoVisibleTypeChanged || isLogoNameChanged || isLogoFileChanged);

  useEffect(() => {
    getCompanyInfo();
  }, []);

  return (
    <Box>
      {clickApply && (
        <AlarmApply
          title="앱 메인화면을 변경하시겠습니까?"
          subtitle="랭킹마라톤 앱 기업모드 화면에 변경사항이 반영됩니다. 변경하여 노출하시겠습니까?"
          handleApply={handleUpdateLogoName}
          handleClickX={() => setClickApply(false)}
        />
      )}
      <div className="hrz-wrapper">
        <RightBracket
          stroke="#b0b0b0"
          width="32px"
          height="32px"
          style={{ transform: "rotate(180deg)", cursor: "pointer" }}
          onClick={handleClickBack}
        />
        <p className="bold-text" style={{ fontSize: "24px" }}>
          앱 메인화면 로고 설정
        </p>
        <IconCrossRound
          style={{ marginLeft: "auto", cursor: "pointer" }}
          onClick={handleClickX}
        />
      </div>

      <p style={{ marginTop: "30px" }}>
        랭킹마라톤 기업모드 앱 화면 좌측 상단에 노출할 로고를 설정해주세요.
      </p>

      <div className="hrz-wrapper center" style={{ marginTop: "30px" }}>
        <RadioButton
          option1="기본"
          option2="직접 입력"
          option3="로고 이미지"
          optionChange={(num) => setCustom(num)}
          selectedOption={custom}
        />
      </div>

      {custom === 0 && (
        <div className="center" style={{ marginTop: "30px" }}>
          <img src={logoEx} />
        </div>
      )}

      {custom === 1 && (
        <div>
          <div className="center" style={{ marginTop: "30px" }}>
            <img src={LogoExCustom} />
          </div>
          <div className="center" style={{ marginTop: "30px" }}>
            <div>
              <p style={{ marginBottom: "8px" }}>국내 기업명*</p>
              <InputBoxDisableTrans
                initialValue={nameKr}
                type="companyName"
                message="ex) 랭킹마라톤"
                handleInput={(value) => setNameKr(value)}
                setError_message={null}
              />

              <p style={{ marginTop: "18px", marginBottom: "8px" }}>
                해외 기업명*
              </p>
              <InputBoxDisableTrans
                initialValue={nameEn}
                type="companyName"
                message="ex) Ranking"
                handleInput={(value) => setNameEn(value)}
                setError_message={null}
              />
              <div className="hrz-wrapper" style={{ marginTop: "8px" }}>
                <IconInfo fill="#b0b0b0" />
                <p
                  style={{
                    color: "#888888",
                    fontSize: "14px",
                    marginLeft: "4px",
                  }}
                >
                  국내/해외별 앱 메인화면에 노출될 기업명을 설정해주세요.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
      {custom === 2 && (
        <div className="scrollView" style={{ height: "500px", width: "500px" }}>
          <p
            style={{
              fontSize: "16px",
              color: "#f25c5c",
              marginTop: "30px",
            }}
            className="medium-text center"
          >
            *규격 : 560 x 136px / 배경 투명화 필수
          </p>
          <div className="center">
            <LogoRegister
              initialLogo={
                typeof appLogo === "string" && appLogo
                  ? `${process.env.REACT_APP_IMAGE_BASE_URL}/${appLogo}`
                  : ""
              }
              onSetLogo={(file) => {
                setAppLogo(file);
                setHasPendingLogoFile(file !== null);
              }}
              step="step2"
            />
          </div>
          <div style={{ height: "30px" }} />
          <div className="center">
            <div>
              <p>ex{")"} 배경 투명화 미적용 시</p>
              <img src={LogoExNotTrans} style={{ margin: "8px 0px" }} />
              <p>ex{")"} 배경 투명화 적용 시</p>
              <img src={LogoExTrans} style={{ margin: "8px 0px" }} />

              <div style={{ display: "flex" }}>
                <IconInfo fill="#b0b0b0" />
                <p
                  style={{
                    marginLeft: "6px",
                    fontSize: "14px",
                    color: "#888888",
                  }}
                >
                  지정된 규격의 투명화된 파일을 업로드해주세요.
                  <br />
                  사이즈가 상이하면 이미지가 깨질 가능성이 있습니다.
                  <br />
                  참조{")"} 배경색 #00EF89
                </p>
              </div>
            </div>
          </div>
          <div
            className="blueBtn-base"
            style={{
              width: "500px",
              height: "56px",
              borderRadius: "10px",
              marginTop: "30px",
              backgroundColor: isButtonEnabled ? "#1167ed" : "#b0b0b0",
            }}
            onClick={isButtonEnabled ? () => setClickApply(true) : null}
          >
            변경하기
          </div>
        </div>
      )}

      {custom !== 2 && (
        <div
          className="blueBtn-base"
          style={{
            width: "500px",
            height: "56px",
            borderRadius: "10px",
            marginTop: "30px",
            backgroundColor: isButtonEnabled ? "#1167ed" : "#b0b0b0",
          }}
          onClick={isButtonEnabled ? () => setClickApply(true) : null}
        >
          변경하기
        </div>
      )}
    </Box>
  );
};

const Box = styled.div`
  width: auto;
  height: 646px;
  padding: 30px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
`;

const SetLogo = ({ handleClickBack, handleClickX }) => {
  return (
    <LayoutModal
      Modal={
        <SetLogoBox
          handleClickBack={handleClickBack}
          handleClickX={handleClickX}
        />
      }
    />
  );
};

export default SetLogo;
